import { makeStyles } from '@material-ui/core';



const useStyles = makeStyles((theme) => ({
 voluntaryMarketContainer:{
    marginTop:60,
      [theme.breakpoints.down('sm')]: {
     marginTop:40,
    },
       [theme.breakpoints.down('md')]: {
     marginTop:40,
    },
     [theme.breakpoints.down('xs')]: {
     marginTop:40,
    },
    
 },
 textHeader:{
      color: theme.palette.text.nonary,
    fontSize: '56px',
    fontFamily: 'MontserratBold',
    fontWeight: '700',
    lineHeight: '74px',
    textAlign: 'center',
    marginBottom: '77px',
    margin: '0px',
 }
}));

export default useStyles;